import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  location: string;
  headline?: string;
  avatarUrl?: string;
}
export function TestimonialCard({
  quote,
  author,
  location,
  headline,
  avatarUrl
}: TestimonialCardProps) {
  return <div className="bg-slate-50 p-6 rounded-xl border border-slate-100 shadow-sm my-6" data-id="element-44">
      <div className="flex gap-1 text-yellow-400 mb-3" data-id="element-45">
        {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-46" />)}
      </div>
      {headline && <h4 className="font-sans font-bold text-slate-900 text-lg mb-2" data-id="element-47">
          "{headline}"
        </h4>}
      <blockquote className="font-serif text-slate-700 italic leading-relaxed mb-4" data-id="element-48">
        "{quote}"
      </blockquote>
      <div className="flex items-center gap-3" data-id="element-49">
        {avatarUrl ? <img src={avatarUrl} alt={author} className="w-12 h-12 rounded-full object-cover border-2 border-slate-200" data-id="element-50" /> : <div className="w-12 h-12 rounded-full bg-slate-200 flex items-center justify-center text-slate-500 font-bold text-sm border-2 border-slate-200" data-id="element-51">
            {author.charAt(0)}
          </div>}
        <div className="text-sm" data-id="element-52">
          <span className="font-bold text-slate-900 block" data-id="element-53">{author}</span>
          <span className="text-slate-500" data-id="element-54">{location}</span>
        </div>
      </div>
    </div>;
}